/**
 * Policy Routes
 * ============================================================================
 *
 * Purpose:
 * --------
 * Defines policy-related routes.
 * ============================================================================
 */

import { lazy } from 'react';
import { LAYOUT_TYPES, ROUTE_PATHS, USER_ROLES } from 'navigation/constants';
import type { RouteGroup } from 'navigation/types';

const PoliciesPage = lazy(() => import('@/features/policies/ui/pages/policies-page'));
const PolicyDetailPage = lazy(() => import('@/features/policies/ui/pages/policy-detail-page'));
const PolicyCreatePage = lazy(() => import('@/features/policies/ui/pages/add-policy-page'));
const PolicyEditPage = lazy(() => import('@/features/policies/ui/pages/policy-detail-page'));

export const policyRoutes: RouteGroup = {
  name: 'policies',
  layout: LAYOUT_TYPES.DASHBOARD,
  permission: {
    requiresAuth: true,
  },
  routes: [
    {
      path: ROUTE_PATHS.POLICIES,
      component: PoliciesPage,
      meta: {
        title: 'policies:title',
        icon: 'DocumentTextIcon',
        showInNav: true,
        navOrder: 3,
      },
    },
    {
      path: ROUTE_PATHS.POLICY_CREATE,
      component: PolicyCreatePage,
      permission: {
        allowedRoles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN, USER_ROLES.AGENT],
      },
      meta: {
        title: 'policies:create.title',
        parent: ROUTE_PATHS.POLICIES,
      },
    },
    {
      path: ROUTE_PATHS.POLICY_DETAIL,
      component: PolicyDetailPage,
      meta: {
        title: 'policies:detail.title',
        parent: ROUTE_PATHS.POLICIES,
      },
    },
    {
      path: ROUTE_PATHS.POLICY_EDIT,
      component: PolicyEditPage,
      permission: {
        allowedRoles: [USER_ROLES.SUPER_ADMIN, USER_ROLES.ADMIN],
      },
      meta: {
        title: 'policies:edit.title',
        parent: ROUTE_PATHS.POLICY_DETAIL,
      },
    },
  ],
};
